export enum EventPricingFilter {
	ALL = "",
	LOWEST_TO_HIGHEST = "ASC",
	HIGHEST_TO_LOWEST = "DESC",
}
